import React from 'react';
import { Container } from 'reactstrap';
import HagleyRoadMap from './hagley-road-map.png';
import HagleyRoadLine from './hagley-road-line.png';
import AddSite from './add-site.png';
import InvitePic from './invite.png';

const ThePlatform = () => (
  <div>

    <Container>

      <div className="mt-5">
        <p className="lead">The Wintersense Platform comprises two key components:</p>
        <ol>
          <li>The back-end services responsible for data processing.</li>
          <li>The front-end <a href="https://user.wintersense.com">Web Application</a> for data visualisation and Network management.</li>
        </ol>
        <p className="lead">They work together to turn sensor data into reliable, actionable information.</p>
      </div>
      

      <section className="mt-5">
        <div className="row align-items-center">
          <div className="col-md">
            <h3>Inform decisions with real-time data</h3>
            <p className="text-justify">To see savings and improve saftey the data collected must inform and modify winter road maintanence operations.</p>
            <p>The Wintersense platform does this in several ways:</p>
            <ul>
              <li>Sensor data is clearly presented on the <a href="https://user.wintersense.com">Web Application</a> using visualisations such as maps and line charts, providing insights into the current (or historical) state of your road network.</li>
              <li>Visualisations update in real-time as soon as more data is received.</li>
              <li>Wintersense recognises that every organisation has its own decision procedures and existing software systems. The Wintersense <a href="https://docs.wintersense.com/api/v1">API</a> makes it easy to <strong>pull</strong> Wintersense data into your own systems.</li>
              <li>The platform can even <strong>push</strong> data straight to you as soon as it arrives.</li>
            </ul>
            <blockquote className="blockquote">
              <p>It's your data; you're free to use it how you like.</p>
            </blockquote>            
          </div>
          <div className="col-md">
            <img src={HagleyRoadMap} className="img-fluid rounded" alt="Wintersense sensor" />
          </div>
        </div>
      </section>


      <section className="mt-5">
        <div className="row align-items-center">
          <div className="col-md order-md-2">
            <h3>Manage as much or as little as you wish</h3>
            <p className="text-justify">The Wintersense team are on hand to setup and manage your sensor network. However, you're also free to configure and adjust your networks as you wish via the <a href="https://user.wintersense.com">Web Application</a>.</p>
            <p>Here's what you can do:</p>
            <ul>
              <li>Add new <em>Sensors</em> to your <em>Network</em>, or remove existing ones.</li>
              <li>Create, update or delete the list of <em>Sites</em>.</li>
              <li><em>Sensors</em> are the physical devices, whereas <em>Sites</em> are the places they are deployed. You're free to move <em>Sensors</em> between <em>Sites</em> to suit your operational needs.</li>
            </ul>
          </div>
          <div className="col-md order-md-1">
            <img src={AddSite} className="img-fluid rounded" alt="Wintersense sensor" />
          </div>
        </div>
      </section>      


      <section className="mt-5">
        <div className="row align-items-center">
          <div className="col-md">
            <h3>Share with others</h3>
            <p className="text-justify">You'll soon find that other colleagues, clients and collaborators are interested in your network's data. It's easy to grant them access.</p>
            <p>Here's how:</p>
            <ul>
              <li>Send email invitations inviting others to your <em>Network</em>.</li>
              <li>You have control over the level of access granted to each <em>User</em>, from view-only through to full admin rights.</li>
              <li>You can even share individual <em>Sites</em>, for example if part of your network overlaps with another.</li>
              <li>Export Wintersense data in <em>csv</em> format for offline analysis.</li>
            </ul>
          </div>
          <div className="col-md">
            <img src={InvitePic} className="img-fluid rounded" alt="Wintersense sensor" />
          </div>
        </div>
      </section>


      <section className="mt-5">
        <div className="row align-items-center">
          <div className="col-md order-md-2">
            <h3>Data you can trust</h3>
            <p className="text-justify">As with any sensor network, quality control is a vital component to build confidence in the data.</p>
            <p>The Wintersense platform does this as follows:</p>
            <ul>
              <li>Before sensor data is saved, forwarded, or visualised, it is passed through a variety of quality control checks.</li>
              <li>Suspect data is flagged allowing users to easily filter it out. For example, data outside of sensible climatic bounds would be flagged.</li>
              <li>Whenever data is flagged, or a <em>Site</em> becomes in active, an alert is generated so action can be taken quickly to rectify the issue.</li>
            </ul>
          </div>
          <div className="col-md order-md-1">
            <img src={HagleyRoadLine} className="img-fluid rounded" alt="Wintersense sensor" />
          </div>
        </div>
      </section> 

    </Container>

    <br/>


  </div>
);

export default ThePlatform;



// WEBPACK FOOTER //
// ./src/components/ThePlatform/index.js